import { Controller } from "@hotwired/stimulus"

// Card #4393: floating dropdown on a Program sprint board's project tile.
// Mount on the tile wrapper:
//   data-controller="sprint-tile-dropdown"
// Toggle button:
//   data-action="click->sprint-tile-dropdown#toggle"
// Menu element (hidden by default, absolute-positioned in the view):
//   data-sprint-tile-dropdown-target="menu"
//
// The project NAME link inside the same tile uses
// data-action="click->sprint-tile-dropdown#stop" (event.stopPropagation())
// so the two click targets (expand vs navigate) never both fire -- per
// Vela's UX review, card #4386 activity #21719.
export default class extends Controller {
  static targets = ["menu", "chevron"]

  connect() {
    this._onOutsideClick = this._onOutsideClick.bind(this)
    this._onKeydown = this._onKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._onOutsideClick)
    document.removeEventListener("keydown", this._onKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.element.setAttribute("data-sprint-tile-dropdown-open", "true")
    if (this.hasChevronTarget) this.chevronTarget.classList.add("rotate-180")
    document.addEventListener("click", this._onOutsideClick)
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.element.removeAttribute("data-sprint-tile-dropdown-open")
    if (this.hasChevronTarget) this.chevronTarget.classList.remove("rotate-180")
    document.removeEventListener("click", this._onOutsideClick)
    document.removeEventListener("keydown", this._onKeydown)
  }

  // The project name link stops here -- it still navigates normally, it
  // just never also toggles this dropdown.
  stop(event) {
    event.stopPropagation()
  }

  get isOpen() {
    return this.element.hasAttribute("data-sprint-tile-dropdown-open")
  }

  _onOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  _onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
